import React from "react";

export default function Twelve({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M254.37.91H45.63A10.32,10.32,0,0,0,35.42,11.45V287.62a11.67,11.67,0,0,0,11.67,11.66H252.91a11.67,11.67,0,0,0,11.67-11.66V11.45A10.37,10.37,0,0,0,254.37.91Zm5.53,286.71a7,7,0,0,1-7,7H47.09a7,7,0,0,1-7-7v-188l28-30.31,191.77,0Z" />
      {children}
    </svg>
  );
}
